import { createContext, Dispatch, SetStateAction } from 'react';

export const sameIssuerSortDirectionContext = createContext<['ASC' | 'DESC', Dispatch<SetStateAction<'ASC' | 'DESC'>>]>([
  'ASC',
  () => {
    throw new Error('you\'re not in a same issuer sort context');
  },
]);
